import { Button, Color, Flex, Icon, Spacing, Text, useModal } from '@billy/design-system'
import { MouseEvent, ReactElement, useCallback } from 'react'
import { useTranslation } from 'react-i18next'

import { useIntercom } from '../../../../../../../contexts/intercomContext'
import { ModalId } from '../../../../../../../enums/modalId'
import { useSegment } from '../../../../../../../hooks'
import * as Styled from './styles'

export const RecentMessagesBanner = (): ReactElement => {
  const { t } = useTranslation()
  const { close } = useModal(ModalId.HelpModal)
  const { track } = useSegment()
  const { showMessages: showIntercomMessagesTab, unreadConversationsCount } = useIntercom()

  const handleRecentConversationsClick = useCallback(
    (event: MouseEvent) => {
      event.preventDefault()
      track('xxx-help-modal-open-intercom-recent-conversations')
      close()
      showIntercomMessagesTab()
    },
    [close, track, showIntercomMessagesTab],
  )

  return (
    <Styled.RecentMessageWrapper>
      <Flex alignItems="center" gap={Spacing.S16}>
        <Icon icon="messagesSquare" color={Color.White} />
        <Text color={Color.White}>
          {t('help.modal.chat.recent_conversations.description_count', { count: unreadConversationsCount })}
        </Text>
      </Flex>
      <Button variant="outlined" onClick={handleRecentConversationsClick}>
        {t('help.modal.chat.recent_conversations.button')}
      </Button>
    </Styled.RecentMessageWrapper>
  )
}
